//prod
export const apiUrl = "https://decohome75.fr/api/";

//dev
// export const apiUrl = "http://localhost/decoHome75/api/"